import { Box } from "@mui/material";
import PatientProcess from "src/modules/nurse/patient-process/pages/index";

type PatientProcessPanelProps = {
  patientId?: number;
  patientMeta: {
    displayName?: string;
    department?: string;
    upn?: string;
  };
};

export default function PatientProcessPanel({ patientId, patientMeta }: Readonly<PatientProcessPanelProps>) {
  if (typeof patientId !== "number") {
    return null;
  }

  return (
    <Box sx={{ mt: "18px", width: "100%" }}>
      <PatientProcess ptId={String(patientId)} embedded patientMeta={patientMeta} />
    </Box>
  );
}
